"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RevisedNavLink = void 0;
const classnames_1 = __importDefault(require("classnames"));
const epic_games_nav_shared_1 = require("epic-games-nav-shared");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const shared_1 = require("../../../shared");
const UnstyledNavLink = (_a) => {
    var _b, _c;
    var { link = {}, locale = "en-US", className, children, disableHrefTemplate, onClick, onMouseDown } = _a, props = __rest(_a, ["link", "locale", "className", "children", "disableHrefTemplate", "onClick", "onMouseDown"]);
    const closeMenus = (0, shared_1.useCloseAllMenus)();
    const { LinkComponent } = (0, epic_games_nav_shared_1.useLinkComponents)();
    const handleClick = (e) => {
        closeMenus();
        if (onClick) {
            onClick(e);
        }
        if (link.onClick) {
            link.onClick(e);
        }
    };
    const { isExternal, isEmbeddedHeaderFooter, sameOrigin } = (0, epic_games_nav_shared_1.determineExternal)(link.hrefTemplate);
    const safe = !isExternal || sameOrigin;
    const rel = safe ? "" : "noopener noreferrer";
    const target = safe ? "_self" : "_blank";
    return (react_1.default.createElement(LinkComponent, Object.assign({ path: (_b = link.href) !== null && _b !== void 0 ? _b : "", locale: (_c = link.lang) !== null && _c !== void 0 ? _c : locale, externalHrefTemplate: disableHrefTemplate ? undefined : link.hrefTemplate, isEmbedded: isEmbeddedHeaderFooter, explicitLocale: link.explicitLocale, className: (0, classnames_1.default)(className, "site-nav-link", "navlink"), onClick: handleClick, onMouseDown: onMouseDown !== null && onMouseDown !== void 0 ? onMouseDown : epic_games_nav_shared_1.stopFocusOnClick, rel: rel, target: target, role: "menuitem" }, props), children));
};
exports.RevisedNavLink = (0, styled_components_1.default)(UnstyledNavLink) `
	cursor: pointer;
`;
//# sourceMappingURL=RevisedNavLink.atom.js.map